import { useState } from "react";
import { useAuth } from "../../../context/contextAuth";
import { getIpResults } from "../../../api/get/oci/get-ip";
import { scanOciIp } from "../../../api/post/post-oci";

const useOciIp = () => {
  const { user, userId } = useAuth();
  const [ip, setIp] = useState("");
  const [networkResults, setNetworkResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ipScanLoading, setIpScanLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNetworkResults = async (requestedUserId = userId) => {
    const results = await getIpResults(requestedUserId);
    setNetworkResults(Array.isArray(results) ? results : []);
    return Array.isArray(results) ? results : [];
  };

  const initData = async () => {
    if (!user || !userId) return [];
    try {
      return await fetchNetworkResults(userId);
    } catch (fetchError) {
      console.error("Error loading OCI network results:", fetchError);
      setNetworkResults([]);
      return [];
    }
  };

  const handleSubmit = async (event) => {
    event?.preventDefault?.();
    setIpScanLoading(true);
    setError(null);
    try {
      await scanOciIp(userId, ip);
      const results = await fetchNetworkResults(userId);
      setCurrentIndex(Math.max(0, results.length - 1));
    } catch (scanError) {
      setError(scanError);
      throw scanError;
    } finally {
      setIpScanLoading(false);
      setIp("");
    }
  };

  const resetState = () => {
    setIp("");
    setNetworkResults([]);
    setCurrentIndex(0);
    setIpScanLoading(false);
    setError(null);
  };

  return {
    ip,
    setIp,
    networkResults,
    currentIndex,
    setCurrentIndex,
    ipScanLoading,
    error,
    initData,
    fetchNetworkResults,
    handleSubmit,
    resetState,
  };
};

export default useOciIp;

